import React, { useCallback, useContext, useState } from 'react'
import Swal from 'sweetalert2';
import { deleteContactInfoById, emailOtpSend, getContactInfo, phoneOtpSend, postContact,putContact } from '../api/contact';
import { getWordOfDictionary } from '../common/dictionary';
import { AuthContext } from '../context/AuthContext';

export const useContactInfo = () => {
    const [isRefreshing, setIsRefreshing] = useState(false)
    const { setLoading, setError,checkToken } = useContext(AuthContext);
    const [emails, setEmails] = useState([]);
    const [phones, setPhones] = useState([]);
    const [emailMapSelect, setEmailMapSelect] = useState([]);

    const getEmails = async () => {
        checkToken()
        setLoading(true);
        try {
            const { data } = await getContactInfo();
            const arrayEmail = data.data.filter(item => item.typeOfContactId == "MAIL");
            setEmails(arrayEmail);

            setEmailMapSelect(arrayEmail.map((e) => {
                return { id: e.id, value: e.contact, ico: null }
            }))
            setLoading(false);
            return true;
        } catch (error) {
            setLoading(false);
            setEmails([]);
            setEmailMapSelect([])
            return false;
        }
    }

    const getPhones = async () => {
        checkToken()
        try {
            setLoading(true);
            const { data } = await getContactInfo();
            const arrayPhone = data.data.filter(item => item.typeOfContactId === "PHONE");
            //console.log(arrayPhone);
            setPhones(arrayPhone);
            setLoading(false);
            return true;
        } catch (error) {
            setLoading(false);
            //console.log(error);
            setPhones([]);
            return false;
        }
    }

    const deleteContactInfo = async (typeOfContactId, id) => {
        checkToken()
        setLoading(true);
        try {
            const { data } = await deleteContactInfoById(id);
            if (typeOfContactId == "PHONE") {
                setPhones(phones.filter((item) => item.id !== id));
            }
            if (typeOfContactId == "MAIL") {
                setEmails(emails.filter((item) => item.id !== id));
            }
            setLoading(false);
            return true;
        } catch (error) {
            setLoading(false);
        }
    }

    const editContactInfo = async (id,dataa) => {
        checkToken()
        setLoading(true);
        try {
            const { data } = await putContact(id,dataa);
            setLoading(false);
            return true;
        } catch (error) {
            setLoading(false);
        }
    }

    const sendOtpPhone = async (phone) => {
        checkToken()
        try {
            setLoading(true)
            const { data } = await phoneOtpSend(phone);
            //console.log(data);
            setLoading(false);
            return { code: data.code, status: data.code, data: data.data };
        } catch (e) {
            setLoading(false);
            //console.log(getWordOfDictionary(e.response.data.code))
            setError(getWordOfDictionary(e.response.data.code));
            return { code: null, status: e.response.data.msg };

        }
    }

    const sendOtpEmail = async (email) => {
        checkToken()
        setLoading(true)
        try {
            const { data } = await emailOtpSend(email);
            setLoading(false);
            return { code: data.code, status: data.code, data: data.data };
            // return [true,data];
        } catch (e) {
            setLoading(false);
            if (e.response.data.message == "Internal server error"){
                Swal.fire({
                    showCloseButton: true,
                    title: 'Advertencia',
                    text: "Su solicitud no puede ser procesada",
                    icon: 'warning',
                    showCancelButton: false,
                    confirmButtonColor: '#fd6e0d',
                    iconColor: "#fd6e0d",
                    confirmButtonText: 'Entendido'
                  })
            } else {
                if (e.response.data.message == "Internal server error"){}
                Swal.fire({
                    showCloseButton: true,
                    title: 'Advertencia',
                    text: "Su solicitud no puede ser procesada",
                    icon: 'warning',
                    showCancelButton: false,
                    confirmButtonColor: '#fd6e0d',
                    iconColor: "#fd6e0d",
                    confirmButtonText: 'Entendido'
                  })
            }
            return { code: null, status: e.response.data.msg };
            // setError(getWordOfDictionary(e.response.data.code));
            // return [false,e.response.data.message];
        }
    }

    const createContact = async (data) => {
        checkToken()
        try {
            setLoading(true)
            const resp = await postContact(data);
            //console.log(data);
            setLoading(false);
            return true;
        } catch (error) {
            setLoading(false);
            console.log(error)
            return false;
        }
    }


    const loadEmails = useCallback(
        async () => {
            setIsRefreshing(true);
            await getEmails();
            setIsRefreshing(false);
        }
    )

    const loadPhones = useCallback(
        async () => {
            setIsRefreshing(true);
            await getPhones();
            setIsRefreshing(false);
        }
    )

    /* Convert string in lowerCase and remove spaces */
    const normalizeEmail = (email) => {
        return email.toLowerCase().replace(/\s/g, '');
    }

    return {
        emails,
        getEmails,
        deleteContactInfo,
        loadEmails,
        isRefreshing,
        getPhones,
        phones,
        loadPhones,
        normalizeEmail,
        sendOtpPhone,
        sendOtpEmail,
        createContact,
        editContactInfo,
        emailMapSelect
    }
}
